import { render } from "./SideNavigationBar.vue?vue&type=template&id=3ab5086a"
import script from "./SideNavigationBar.vue?vue&type=script&lang=js"
export * from "./SideNavigationBar.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__